import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { LuxonService } from './luxon.service';

export function provideLuxon(): Array<Provider | EnvironmentProviders> {
  return [
    provideEnvironmentInitializer(() => inject(LuxonService))
  ];
}
